import _objectSpread from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["id"];
import { watchEffect, nextTick, onUnmounted } from 'vue';
import * as echarts from 'echarts';
export default {
  __name: 'dobarAnalysis',
  props: {
    id: {
      type: String,
      default: 'echart'
    },
    data: {
      type: Object,
      default: function _default() {}
    }
  },
  setup: function setup(__props) {
    var props = __props;
    // const data = {
    //   title: '本周课堂组织情况',
    //   legend: ['用课平台次数', '学程授课占比', '展示次数占比', '有展示课次学生参与率'],
    //   xAxis: ['六年级', '七年级', '八年级', '九年级', '高一', '高二', '高三'],
    //   series: [
    //     { name: '用课平台次数', data: [300, 650, 1700, 520, 639, 500, 300] },
    //     { name: '学程授课占比', data: [200, 0.8, 0.4, 0.8, 0.95, 0.6, 0.5] },
    //     { name: '展示次数占比', data: [0.8, 0.6, 300, 0.8, 0.3, 0.4, 0.955] },
    //     { name: '有展示课次学生参与率', data: [0.8, 0.95, 0.6,400, 0.4, 0.8, 0.6] },
    //   ],
    // }
    var series = [{
      name: '',
      type: 'bar',
      stack: 'Total',
      barWidth: '20px',
      yAxisIndex: 0,
      itemStyle: {
        color: '#295AF6'
      },
      areaStyle: {},
      emphasis: {
        focus: 'series'
      },
      data: []
    }, {
      name: '',
      type: 'bar',
      stack: 'Total',
      yAxisIndex: 0,
      emphasis: {
        focus: 'series'
      },
      itemStyle: {
        color: '#ECBD45'
      },
      data: []
    }, {
      name: '',
      type: 'bar',
      stack: 'Total',
      yAxisIndex: 0,
      emphasis: {
        focus: 'series'
      },
      itemStyle: {
        color: '#692FC8'
      },
      data: []
    }, {
      name: '',
      type: 'bar',
      stack: 'Total',
      yAxisIndex: 0,
      emphasis: {
        focus: 'series'
      },
      itemStyle: {
        color: '#4E8FF1'
      },
      data: []
    }];
    var timer = null;
    var echartData = function echartData(data) {
      // let myChart1 = echarts.init(document.getElementById(props.id))
      var dom = document.getElementById(props.id);
      console.log(dom, '---dom', props.id);
      if (!dom) return;
      console.log(data, 91);
      var myChart1 = echarts.init(dom);
      var newSeries = data.series.map(function (item, index) {
        return _objectSpread(_objectSpread({}, series[index]), {}, {
          name: item.name,
          data: item.data
        });
      });
      var option = {
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        yAxis: [{
          type: 'value',
          name: '',
          position: 'left'
        }],
        legend: {
          top: 0,
          data: data.legend
        },
        xAxis: {
          type: 'category',
          data: data.xaxis
        },
        series: newSeries
      };
      option && myChart1.setOption(option);
      timer = setTimeout(function () {
        myChart1.resize();
      }, 100);
    };
    watchEffect(function () {
      if (props.data && Object.keys(props.data).length > 0) {
        nextTick(function () {
          echartData(props.data);
        });
      }
    });
    onUnmounted(function () {
      if (timer) {
        clearTimeout(timer);
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        id: __props.id,
        style: {
          "width": "100%",
          "height": "368px"
        }
      }, null, 8, _hoisted_1);
    };
  }
};